// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { formatNumber } from "@mcmc/App/Components/FormattedNumber/utilities";
import React from "react";

interface Props {
    value: string | number;
    prefix?: string;
    postfix?: string;
}

const FormattedNumber: React.FC<Props & Omit<TypographyPresentationProps, "prefix">> = ({
    value,
    prefix,
    postfix,
    ...otherProps
}) => {
    if (typeof value === "undefined") {
        return null;
    }

    return <Typography {...otherProps}>{formatNumber(value, prefix, postfix)}</Typography>;
};

export default React.memo(FormattedNumber, (preProps, nextProps) => preProps.value !== nextProps.value);
